// eslint-disable-next-line no-undef
const { connectPagination, connectSortBy } = instantsearch.connectors;
const globalSettings = window.Bedrock.global_settings;
const globalLanguage = window.Bedrock.language;
const savedPlpUrl = sessionStorage.getItem("plpUrl");
const savedScrollY = sessionStorage.getItem("scrollY");
const pdpSwatchClicked = sessionStorage.getItem("pdpSwatchClicked");
let initialLoad = true;
let isMobile;
const navigationEntries = performance.getEntriesByType("navigation");
const isBackNavigation =
  navigationEntries.length && navigationEntries[0].type === "back_forward";

function checkMobile() {
  if (window.innerWidth >= 768) {
    isMobile = false;
  } else {
    isMobile = true;
  }
}
checkMobile();

function scrollBack() {
  const isPLP = window.location.href.includes("/collections/");
  const savedScrollY = sessionStorage.getItem("scrollY");
  const pdpReferred = sessionStorage.getItem("pdpReferrer");
  const samePLP = window.location.href === pdpReferred;
  if (isPLP && samePLP && savedScrollY) {
    window.scrollTo({
      top: parseInt(savedScrollY, 10),
      behavior: "auto",
    });
    sessionStorage.removeItem("scrollY");
    sessionStorage.removeItem("pdpSwatchClicked");
    sessionStorage.removeItem("pdpReferrer");
  }
}

// fix for safari
window.addEventListener("popstate", scrollBack);
window.addEventListener("pageshow", () => {
  const pdpSwatchClicked = sessionStorage.getItem("pdpSwatchClicked");
  if (
    (window.performance && window.performance.navigation.type === 2) ||
    (window.performance &&
      window.performance.navigation.type === 0 &&
      pdpSwatchClicked)
  ) {
    scrollBack();
  }
});

document.addEventListener("algolia.hooks.initialize", function () {
  // eslint-disable-next-line no-secrets/no-secrets
  // Needed for "Merchandising Studio with Shopify" https://support.algolia.com/hc/en-us/articles/17193209523857-How-can-I-use-the-Merchandising-Studio-with-Shopify
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      if (defaultFilter && defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(
          /\/collections\/([^/]+)/i
        );

        const collectionHandle =
          matches && matches.length === 2 ? matches[1] : null;

        if (collectionHandle) {
          return defaultFilter.replace(
            collectionIDFilterRegex,
            "collections:" + collectionHandle
          );
        }
      }
      return defaultFilter;
    }
  );

  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchOptions",
    function (_defaultTemplate) {
      for (let widget of _defaultTemplate.facets.widgets) {
        // Remove 'show more' button on Desktop
        if (!isMobile) {
          widget.params.limit = 15;
          widget.params.showMore = false;
        } else {
          widget.params.limit = 6;
          widget.params.showMore = true;
          widget.params.showMoreLimit = 15;
        }
      }

      return _defaultTemplate;
    }
  );

  // Create the custom pagination widget to get text to add above Load More
  const renderPagination = (renderOptions) => {
    const hitsPerPage = globalSettings.plp_number_of_results_per_page;
    const {
      nbHits,
      pages,
      currentRefinement,
      isFirstPage,
      isLastPage,

      createURL,
    } = renderOptions;

    const container = document.querySelector("#pagination");
    const start = hitsPerPage * currentRefinement + 1;
    const end = Math.min((currentRefinement + 1) * hitsPerPage, nbHits);
    const currentlyShowing = `${start}-${end}`;

    if (container) {
      if (nbHits > 0) {
        container.innerHTML = `
          <ul class="ais-Pagination-list">
        ${
          !isFirstPage
            ? `
              <li class="ais-Pagination-item ais-Pagination-item--previousPage">
                <a
                  href="${createURL(currentRefinement - 1)}"
                  data-value="${currentRefinement - 1}"
                  class="ais-Pagination-link"
                  aria-label="Previous Page"
                >
                  Previous
                </a>
              </li>
              `
            : ""
        }
        ${
          nbHits > hitsPerPage
            ? pages
                .map(
                  (page) => `
                    <li class="ais-Pagination-item ais-Pagination-item--page ${
                      currentRefinement === page
                        ? "ais-Pagination-item--selected"
                        : ""
                    }">
                      <a
                        href="${createURL(page)}"
                        data-value="${page}"
                        class="ais-Pagination-link"
                        aria-label="Page ${page + 1}"
                      >
                        ${page + 1}
                      </a>
                    </li>
                  `
                )
                .join("")
            : ""
        }
          ${
            !isLastPage
              ? `
                <li class="ais-Pagination-item ais-Pagination-item--nextPage">
                  <a
                    href="${createURL(currentRefinement + 1)}"
                    data-value="${currentRefinement + 1}"
                    class="ais-Pagination-link"
                    aria-label="Next Page"
                  >
                    Next
                  </a>
                </li>
                `
              : ""
          }
        </ul>
        <p class="ais-Pagination__showing-text">Showing ${currentlyShowing} of ${nbHits}</p>
      `;
      } else {
        container.innerHTML = "";
      }
    }

    function redirectWithQueryParams(pageValue) {
      const currentUrl = new URL(window.location.href);
      const currentParams = currentUrl.searchParams;
      currentParams.set("page", pageValue);
      const newUrl = `${currentUrl.pathname}?${currentParams.toString()}`;
      window.location.href = newUrl;
    }

    [...container.querySelectorAll("a")].forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        const pageValue = parseInt(event.currentTarget.dataset.value) + 1;
        redirectWithQueryParams(pageValue);
      });
    });
  };

  // Add infiniteHits
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
    // Show facet values before applying distinct
    const { configure } = window.instantsearch.widgets;
    const isSearch = window.location.href.includes("search?q=");
    let analyticsTagsArray = [];
    const analyticTag = isSearch ? "search" : "browse";
    analyticsTagsArray.push(analyticTag);

    const configureWidget = configure({
      facetingAfterDistinct: false,
      analyticsTags: analyticsTagsArray,
    });

    // Create custom pagination to get info to add above load more
    const customPagination = connectPagination(renderPagination);
    const customPaginationWidget = customPagination({
      container: document.querySelector("#pagination"),
      showFirst: false,
      showLast: false,
      padding: 2,
      scrollTo: false,
    });

    // Create the render function
    const renderSortBy = (renderOptions, isFirstRender) => {
      const { options, currentRefinement, refine, widgetParams, canRefine } =
        renderOptions;

      const init = () => {
        if (isFirstRender) {
          const select = document.createElement("select");

          select.addEventListener("change", (event) => {
            refine(event.target.value);
          });

          widgetParams.container.appendChild(select);
        }

        const select = widgetParams.container.querySelector("select");
        select.style.display = "none";
        select.disabled = !canRefine;

        select.innerHTML = `
          ${options
            .map(
              (option) => `
                <option
                  value="${option.value}"
                  ${option.value === currentRefinement ? "selected" : ""}
                >
                  ${option.label}
                </option>
              `
            )
            .join("")}
        `;

        const isValidRefinement = options.some(
          (option) => option.value === currentRefinement
        );
        if (!isValidRefinement) {
          refine(options[0].value);
        }
      };

      if (!widgetParams.container) {
        const observer = new MutationObserver((mutations, obs) => {
          if (widgetParams.container) {
            init();
            obs.disconnect();
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        init();
      }
    };

    // Create the custom widget
    const customSortBy = connectSortBy(renderSortBy);

    // If this is a PLP with the collection type metafield populated, use the custom index as the default "Featured" sort
    const collectionType = window.collectionType;
    // eslint-disable-next-line no-undef
    const algoliaIndexPrefix = algoliaShopify.config.index_prefix;
    let featuredSort = `${algoliaIndexPrefix}products`;
    if (collectionType && collectionType !== "") {
      // eslint-disable-next-line no-undef
      featuredSort = `${algoliaIndexPrefix}products_${collectionType}`;
    }

    // Instantiate the custom widget and rename the first 2 labels
    const customSortByWidget = customSortBy({
      container: document.querySelector(".ais-search-header"),
      items: [
        { label: `${globalLanguage.featured_sort}`, value: featuredSort },
        {
          label: `${globalLanguage.best_sellers_sort}`,
          value: `${algoliaIndexPrefix}products_recently_ordered_count_desc`,
        },
        {
          label: `${globalLanguage.newest_sort}`,
          value: `${algoliaIndexPrefix}products_published_at_desc`,
        },
        {
          label: `${globalLanguage.price_asc}`,
          value: `${algoliaIndexPrefix}products_price_asc`,
        },
        {
          label: `${globalLanguage.price_desc}`,
          value: `${algoliaIndexPrefix}products_price_desc`,
        },
      ],
    });

    // Customize banner and inject into grid
    const { queryRuleCustomData } = window.instantsearch.widgets;
    const queryRuleCustomDataWidget = queryRuleCustomData({
      container: "#algolia-queryrulecustomdata",
      templates: {
        default({ items }, { html }) {
          let disruptorMarkup = "";
          let disruptorIndex = 1;

          for (let i = 0; i < items[0]?.disruptors?.length; i++) {
            const disruptorId = `disruptor-${disruptorIndex}`;

            if (document.querySelector(`#${disruptorId}`)) {
              disruptorIndex++;
              continue;
            }

            let currentDisruptor = items[0]?.disruptors[i];
            const image_desktop = currentDisruptor.image_desktop;
            const image_mobile = currentDisruptor.image_mobile;
            const text_bg_color = currentDisruptor.text_bg_color;
            const title = currentDisruptor.title;
            const body_text = currentDisruptor.body_text;
            const cta_label = currentDisruptor.cta_label;
            const cta_url = currentDisruptor.cta_url;
            let position = currentDisruptor.position;
            let desktop_column_span = currentDisruptor.desktop_column_span;
            let mobile_column_span = currentDisruptor.mobile_column_span;
            let text_color = currentDisruptor.text_color || "#131E0F";
            let cta_style = currentDisruptor.cta_style;
            let disruptor_text_styles = "";
            let bg_image_css = "";
            let enable_card_link = currentDisruptor.enable_card_link || false;

            if (!position) {
              return;
            }

            // If enable_card_link is set to true but there isn't a url, set it back to false
            if (enable_card_link && !cta_url) {
              enable_card_link = false;
            }

            if (image_desktop && image_mobile) {
              bg_image_css = `
                <style>
                  #disruptor-${disruptorIndex} .br-disruptor-tile__background-container {

                  }
                  @media (min-width: 1024px) {
                    #disruptor-${disruptorIndex} .br-disruptor-tile__background-container {
                      background-image: image-set(
                        url('${image_desktop}&width=312') 1x,
                        url('${image_desktop}&width=624') 2x
                      );
                    }

                    #disruptor-${disruptorIndex}.br-disruptor-position--desktop-col-span-2 .br-disruptor-tile__background-container {
                      background-image: image-set(
                        url('${image_desktop}&width=647') 1x,
                        url('${image_desktop}&width=1294') 2x
                      );
                    }

                    #disruptor-${disruptorIndex} .br-disruptor-tile__background-container img {
                      display: none;
                    }
                  }
                </style>
              `;
            }

            if (text_bg_color) {
              disruptor_text_styles = `
                background-color: ${text_bg_color};
              `;
            }

            let disruptor_classes = "";
            if (desktop_column_span == 2) {
              disruptor_classes = "br-disruptor-position--desktop-col-span-2";
            }
            if (mobile_column_span == 2) {
              disruptor_classes += " br-disruptor-position--mobile-col-span-2";
            }

            let cta_html = "";
            if (!cta_style) {
              cta_style = "primary";
            }
            if (cta_label && cta_url) {
              cta_html = `<button class="br-disruptor-tile__cta br-button br-button--${cta_style} br-button--handdrawn" onclick="goToPage(event,'${cta_url}')">
                ${cta_label}
              </button>`;
            }

            disruptorIndex++;

            disruptorMarkup += `
              <li id="disruptor-${
                disruptorIndex - 1
              }" class="${disruptor_classes} br-disruptor" style="order: ${position}">
                ${bg_image_css}
                ${getProductSkeletonHTML(null, position)}
                <div class="relative !hidden flex-col h-full overflow-hidden text-left text-white br-disruptor-tile" role="group" aria-label="disruptor tile" style="color: ${text_color} !important;">
                  ${
                    enable_card_link
                      ? `<a href="${cta_url}" class="br-disruptor-tile__link" style="color: ${text_color} !important;">`
                      : ""
                  }
                  <div class="br-disruptor-tile__background-container br-disruptor-tile__background-container--no-image">
                    <img
                      src="${image_mobile}"
                      ${
                        mobile_column_span === 1 &&
                        `srcset="
                          ${image_mobile}&width=187 187w,
                          ${image_mobile}&width=374 374w,
                          ${image_mobile}&width=561 561w
                        "
                        sizes="
                          (max-width: 768px) 50vw,
                          (max-width: 1024px) 33vw,
                          0
                        "
                        `
                      }
                      ${
                        mobile_column_span === 2 &&
                        `srcset="
                          ${image_mobile}&width=382 382w,
                          ${image_mobile}&width=764 764w,
                          ${image_mobile}&width=1146 1146w
                        "
                        sizes="
                          (max-width: 768px) 100vw,
                          (max-width: 1024px) 50vw,
                          0
                        "
                        `
                      }
                      alt=""
                    />
                  </div>
                  <div class="flex flex-col items-baseline justify-end w-full gap-2 br-disruptor-tile__content" style="${disruptor_text_styles}">
                    <div class="w-full">
                      ${
                        title &&
                        `
                        <h4 class="mb-1">${title}</h4>
                      `
                      }
                      ${
                        body_text &&
                        `
                        <p>${body_text}</p>
                      `
                      }
                    </div>
                    ${cta_html}
                  </div>
                  ${enable_card_link ? `</a>` : ""}
                </div>
              </li>
            `;

            globalSettings.disruptorExists = true;
          }

          // eslint-disable-next-line prettier/prettier
          return html` 
            ${disruptorMarkup} 
          `;
        },
      },
    });

    return [
      configureWidget,
      customPaginationWidget,
      customSortByWidget,
      queryRuleCustomDataWidget,
    ];
  });
});

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
let searchString = params.q;

// eslint-disable-next-line no-inner-declarations, no-unused-vars
function goToPage(event, url) {
  event.stopPropagation();
  window.location.href = url;
}

function toggleDisruptors() {
  const disruptors = document.querySelectorAll(".br-disruptor");

  // Check if any filters are applied
  const filtersApplied =
    document.querySelectorAll(".ais-current-refined-values--item").length > 0;

  // Hide all disruptors if filters are applied
  if (filtersApplied) {
    disruptors.forEach((disruptor) => {
      disruptor.style.display = "none";
    });
    return;
  }

  // Only display disruptors if filters are NOT applied
  if (disruptors.length) {
    const hitsPerPage = globalSettings.plp_number_of_results_per_page;
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = urlParams.get("page") || 1;
    const startRange = (currentPage - 1) * hitsPerPage + 1;
    const endRange = currentPage * hitsPerPage;
    const productCards = document.querySelectorAll(
      ".ais-Hits-item:not(.br-disruptor)"
    );

    // Check product results and only show corresponding disruptors
    disruptors.forEach((disruptor) => {
      const disruptorOrder = disruptor.style.order;
      if (disruptorOrder >= startRange && disruptorOrder <= endRange) {
        // Move disruptor and display it in the correct order
        const matchingProductCard = Array.from(productCards).find((card) => {
          return card.style.order === disruptorOrder;
        });
        if (matchingProductCard) {
          matchingProductCard.before(disruptor);
        }
        disruptor.style.display = "list-item";
      } else {
        disruptor.style.display = "none";
      }
    });
  }
}

function waitForAlgoliaGrid() {
  hasGridLoaded();

  let attempts = 0;
  const interval = setInterval(function () {
    if (hasGridLoaded() || attempts > 100) {
      clearInterval(interval);
    }
    attempts++;
  }, 100);
}

function hasGridLoaded() {
  const algoliaGrid = document.querySelector(".ais-Hits-list");
  const originalDisruptorDiv = document.querySelector(
    ".ais-QueryRuleCustomData"
  );

  if (algoliaGrid) {
    // Move disruptors into the algolia grid
    if (originalDisruptorDiv) {
      while (originalDisruptorDiv.firstChild) {
        algoliaGrid.prepend(originalDisruptorDiv.firstChild);
      }
    }
    toggleDisruptors();
    assignSkeletonOrders();
    return true;
  }
  return false;
}

(function () {
  waitForAlgoliaGrid();
})();

document.addEventListener("algolia.hooks.initialize", function () {
  function updateSelectedFilterLabels() {
    const selectedFiltersItems = document.querySelectorAll(
      ".ais-current-refined-values--item a"
    );
    if (selectedFiltersItems) {
      selectedFiltersItems.forEach(function (item) {
        const refinedValueLabel = item.querySelector("div");
        // Check for any price range options and add formatting
        if (refinedValueLabel.innerHTML.includes("Price")) {
          let updatedText = refinedValueLabel.innerHTML.replace(
            /:\s*(\d+)\s*:\s*(\d+)/,
            ": $$$1 - $$$2"
          );
          refinedValueLabel.innerHTML = updatedText;
        }
      });
    }
  }

  function sortSwatches(type) {
    const order = globalSettings[`${type}_filter_options`].split(",");
    const list = document.querySelector(
      `.ais-facet-${type} .ais-RefinementList-list`
    );
    if (list) {
      const items = Array.from(list.children);

      // Create a map with the desired order
      const orderMap = order.reduce((map, type, index) => {
        map[type] = index;
        return map;
      }, {});

      // Sort the items based on the order in the array
      items.sort((a, b) => {
        const aValue = a
          .querySelector("label")
          .getAttribute("data-label-value");
        const bValue = b
          .querySelector("label")
          .getAttribute("data-label-value");

        const aOrder = orderMap[aValue];
        const bOrder = orderMap[bValue];

        // Compare the order indices, treating undefined as a higher value
        if (aOrder === undefined) return 1;
        if (bOrder === undefined) return -1;

        return aOrder - bOrder;
      });

      // Append the sorted items back to the list
      items.forEach((item) => list.appendChild(item));
    }
  }

  // Update stats
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchStatsTemplate",
    function (_defaultTemplate, data, html) {
      // Since this hook runs after every filter selection, use it to reset our customizations
      window.setTimeout(() => {
        toggleDisruptors();
      }, 10);
      sortSwatches("color");
      sortSwatches("size");
      if (!initialLoad) {
        toggleSkeletons();
      }
      updateSelectedFilterLabels();

      return html`
        ${window.collectionTitle &&
        data.hasOneResult &&
        html`
          <span
            class="!text-[13px] font-normal !leading-[1.2] max-md:font-light text-primary-900"
          >
            1 ${globalLanguage.product_singular}
          </span>
        `}
        ${window.collectionTitle &&
        data.hasManyResults &&
        html`
          <span
            class="!text-[13px] font-normal !leading-[1.2] max-md:font-light"
          >
            ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${" "}
            ${globalLanguage.product_plural}
          </span>
        `}
        ${!window.collectionTitle &&
        data.hasOneResult &&
        html`
          <span class="ais-stats--nb-results">
            1 ${globalLanguage.search_result_singular}
          </span>
        `}
        ${!window.collectionTitle &&
        data.hasManyResults &&
        html`
          <span class="ais-stats--nb-results">
            ${algoliaShopify.helpers.formatNumber(data.nbHits)}
            ${" "}${globalLanguage.search_result_plural}
          </span>
        `}
      `;
    }
  );

  // Override main Algolia filters template
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    function (_defaultTemplate, data, html) {
      const filterButtonText = `<span>${globalLanguage.filter_button}</span>
        <span class="br-icon" style="--br-icon-color: black; color: black;--br-icon-width: 16px;--br-icon-height: 16px;" aria-hidden="true">
          <svg>
            <use xlink:href="#filter"></use>
          </svg>
        </span>`;

      function addCloseFiltersEvents() {
        window.setTimeout(() => {
          const closeFilterButtons = document.querySelectorAll(
            "[data-action-close-filters]"
          );
          if (closeFilterButtons) {
            closeFilterButtons.forEach((button) => {
              button.addEventListener("click", function () {
                hideMobileFacetView();
                resetFilterButtonText();
              });
            });
          }
        }, 500);
      }

      function hideMobileFacetView() {
        window.setTimeout(() => {
          const facetsDiv = document.querySelector(".ais-facets");
          facetsDiv.classList.remove("ais-facets__shown");
        }, 100);
      }

      function resetFilterButtonText() {
        window.setTimeout(() => {
          const filterButton = document.querySelector(".ais-facets-button");
          // Replace the text that Algolia adds "Hide filters" with the original text and icon
          filterButton.innerHTML = filterButtonText;
        }, 100);
      }

      function addMobileViewResultsCTA() {
        window.setTimeout(() => {
          // Add view results button but keep it hidden until the mobile filters are open
          const facetsDiv = document.querySelector(".ais-facets");

          const viewResultsContainerHTML = `
          <div class="btn--close-filters-container">
            <button data-action-close-filters class="br-button br-button--secondary br-button--handdrawn btn--close-filters btn--close-filters--bottom md:hidden">
              ${globalLanguage.view_results}
            </button>
          </div>
          `;

          const viewResultsContainer = document.querySelector(
            ".ais-page .btn--close-filters-container"
          );
          if (!viewResultsContainer) {
            facetsDiv.insertAdjacentHTML("afterend", viewResultsContainerHTML);
          }
          addCloseFiltersEvents();
        }, 100);
      }

      function checkMobileFilter() {
        if (window.innerWidth >= 768) {
          isMobile = false;
          hideMobileFacetView();
          resetFilterButtonText();
        } else {
          isMobile = true;
          addMobileViewResultsCTA();
        }
      }

      addCloseFiltersEvents();
      checkMobileFilter();

      window.addEventListener("resize", function () {
        checkMobileFilter();
      });

      /*
        - Add an id to the sort select so the label can correctly target it
        - On mobile:
          - click the label or arrow to display the select
          - when changing or blurring from the select, then hide the select
      */

      function waitForSortButton() {
        hasSortLoaded();

        let attempts = 0;
        const interval = setInterval(function () {
          if (hasSortLoaded() || attempts > 100) {
            clearInterval(interval);
          }
          attempts++;
        }, 100);
      }

      function hasSortLoaded() {
        const aisSortArrow = document.querySelector(
          ".ais-sort .br-select__arrow"
        );
        const aisSortSelect = document.querySelector(".ais-SortBy-select");
        if (aisSortArrow && aisSortSelect) {
          document
            .querySelectorAll("select.ais-SortBy-select")
            .forEach((selectElement) => {
              new CustomSelect(selectElement);
            });
          return true;
        }
        return false;
      }

      (function () {
        waitForSortButton();
      })();

      // Add hover dropdowns to facets
      function enableHoverDropdowns() {
        requestAnimationFrame(() => {
          const facetDropdowns = document.querySelectorAll(
            ".ais-facet-dropdown-wrapper details"
          );

          facetDropdowns.forEach((details) => {
            const summary = details.querySelector("summary");

            summary?.addEventListener("mouseenter", () => {
              details.setAttribute("open", "");
            });

            summary?.addEventListener("mouseleave", () => {
              setTimeout(() => {
                if (!details.matches(":hover")) {
                  details.removeAttribute("open");
                }
              }, 200);
            });

            details?.addEventListener("mouseleave", () => {
              details.removeAttribute("open");
            });
          });
        });
      }

      // Helper function to move the clear refinements button to the bottom of the filter list
      function moveClearRefinementsButton() {
        const clearButton = document.querySelector(
          ".ais-ClearRefinements-button"
        );
        const refinedValuesContainer = document.querySelector(
          ".ais-current-refined-values--list"
        );

        if (
          clearButton &&
          refinedValuesContainer &&
          !refinedValuesContainer.contains(clearButton)
        ) {
          refinedValuesContainer.appendChild(clearButton);
        }
      }

      // MutationObserver to move the clear refinements button to the bottom of the filter list
      const observer = new MutationObserver(() => {
        moveClearRefinementsButton();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Call it in case the button is already there
      moveClearRefinementsButton();

      const renderFacets = (facets) => {
        return facets.map((facet) => {
          const classNames = `ais-facet-dropdown-wrapper ais-facet-${
            facet.type
          } ais-facet-${
            facet.escapedName
          } ais-facet-${facet.title.toLowerCase()}`;
          const container = `ais-facet-${facet.escapedName}-container ais-facet-dropdown-container`;

          if (isMobile) {
            return html`
              <div class="${classNames}">
                <label
                  for="${facet.escapedName}"
                  class="ais-range-slider--header ais-facet--header ais-header"
                >
                  ${facet.title}
                </label>
                <input
                  class="ais-dropdown-checkbox"
                  type="checkbox"
                  id="${facet.escapedName}"
                  name="dropdown"
                />
                <span
                  class="br-icon br-accordion-item__plus-icon"
                  aria-hidden="true"
                  style="--br-icon-width: 16px; --br-icon-height: 16px;"
                >
                  <svg><use href="#plus"></use></svg>
                </span>
                <span
                  class="br-icon br-accordion-item__minus-icon"
                  aria-hidden="true"
                  style="--br-icon-width: 16px; --br-icon-height: 16px;"
                >
                  <svg><use href="#minus"></use></svg>
                </span>
                <div class="${container}"></div>
              </div>
            `;
          } else {
            return html`
              <li class="${classNames}">
                <details>
                  <summary
                    class="ais-range-slider--header ais-facet--header ais-header"
                  >
                    ${facet.title}
                    <span class="br-icon br-icon--sm" aria-hidden="true">
                      <svg><use href="#chevron-down"></use></svg>
                    </span>
                  </summary>
                  <div class="${container}"></div>
                </details>
              </li>
            `;
          }
        });
      };

      const renderSortLabel = (isMobile) => html`
        <label for="aisSortSelect" class="ais-sort-label">
          <span class="hidden md:block md:!mr-1">
            ${isMobile
              ? globalLanguage.sort_button
              : globalLanguage.sort_by_label}
          </span>
          <span aria-hidden="true" class="br-select__arrow br-icon br-icon--md">
            <span class="br-icon br-icon--sm" aria-hidden="true">
              <svg><use href="#chevron-down"></use></svg>
            </span>
          </span>
        </label>
      `;

      const renderFilterHeader = () => html`
        <div class="flex justify-between border-grey-700 !pb-6">
          <h3 class="h5 !text-[22px] !border-0 !p-0">Filters</h3>
          <button
            data-action-close-filters
            class="btn--close-filters mr-4"
            style="position: initial;"
          >
            <span class="sr-only">${globalLanguage.close_filters}</span>
            <span
              class="br-icon"
              aria-hidden="true"
              style="--br-icon-color: black; color: black; --br-icon-width: 16px; --br-icon-height: 16px;"
            >
              <svg><use href="#close"></use></svg>
            </span>
          </button>
        </div>
      `;

      const renderTitle = () => html`
        <h1 class="ais-h2">
          ${window.collectionTitle
            ? html`${window.collectionTitle}`
            : html`${algoliaShopify.translations.searchTitle}s
              ${searchString &&
              html` for "${decodeURIComponent(searchString)}"`}`}
        </h1>
      `;

      // The code below will either render the mobile or desktop view based on the isMobile variable
      const filters = html`
        <div class="ais-page loaded">
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>

          <div class="ais-block">
            <div
              class="!mb-4 min-h-[52px] md:min-h-[38px] md:flex md:items-center md:gap-4 md:mb-1 lg:!mb-0 text-primary-900"
            >
              ${renderTitle()}
              ${!isMobile && html`<div class="ais-stats-container h7"></div>`}
            </div>

            <div class="ais-search-header">
              <div class="ais-change-display">
                <span
                  class="ais-change-display-block ais-change-display-selected"
                >
                  <i class="fa fa-th-large"></i>
                </span>
                <span class="ais-change-display-list">
                  <i class="fa fa-th-list"></i>
                </span>
              </div>

              <div
                class="flex items-center gap-x-6 md:gap-x-2 md:justify-end md:grow md:items-start"
              >
                <div
                  id="facets-container"
                  class="ais-facets"
                  aria-label="Filter Navigation"
                >
                  ${isMobile ? renderFilterHeader() : ""}
                  <div
                    class="md:flex md:items-center md:!my-4 border-none order-3"
                  >
                    <div class="ais-current-refined-values-container"></div>
                    <div
                      class="ais-clear-refinements-container md:!relative md:!ml-6"
                    ></div>
                  </div>

                  ${isMobile
                    ? renderFacets(data.facets, true)
                    : html`<ul class="ais-facets-nav">
                        ${renderFacets(data.facets, false)}
                      </ul>`}
                </div>

                <div
                  class="${isMobile
                    ? "ais-facets-button !bg-transparent !border-0"
                    : "ais-facets-button flex basis-1/2 br-button br-button--primary br-button--sm"}"
                >
                  <span class="max-md:font-light max-md:!text-[13px]"
                    >${globalLanguage.filter_button}</span
                  >
                  <span
                    class="br-icon"
                    aria-hidden="true"
                    style="--br-icon-color: black; color: black; --br-icon-width: 16px; --br-icon-height: 16px;"
                  >
                    <svg><use xlink:href="#filter"></use></svg>
                  </span>
                </div>

                ${!isMobile &&
                html`<span
                  class="hidden md:block desktop-text !text-[13px] !mt-3"
                  >Sort:</span
                >`}
                <div
                  class="ais-sort max-md:!bg-transparent max-md:!border-none"
                >
                  ${renderSortLabel(isMobile)}
                  <span class="ais-sort-orders-container"></span>
                </div>

                ${isMobile && html`<div class="ais-stats-container h7"></div>`}
              </div>
            </div>

            <div class="ais-hits-container ais-results-as-block"></div>
            <div id="pagination" class="text-sm text-center"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
      requestAnimationFrame(enableHoverDropdowns);
      return filters;
    }
  );
});

/*
  NOTES:
  - Algolia's objectID is the variant ID
*/

// Override Algolia product card template
document.addEventListener("algolia.hooks.initialize", function () {
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html) {
      // Define variables used by both Algolia and our code
      const index = hit.productPosition;
      const variantID = hit.objectID;
      const productID = hit.id;
      // eslint-disable-next-line no-undef
      const productURL = algoliaShopify.helpers.instantsearchLink(hit);
      // eslint-disable-next-line no-undef
      const productFeaturedImage = algoliaShopify.helpers.largeImage(hit);
      const productTitle = hit.title.split(" - ")[0] || hit.title;
      const productStyleTitle = hit.title.split(" - ")[1] || "";

      let addToCartHTML = "";
      let quickViewShadow = "";
      let quickViewDesktopHTML = "";
      let quickAddHTML = "";

      const handleItemClickInstantSearch = (e, hit) => {
        const container = e.target.closest("[data-product-id-container]");

        // eslint-disable-next-line prettier/prettier
        const productId =
          container?.getAttribute("data-product-id-container") || null;
        // eslint-disable-next-line prettier/prettier
        const currentVariant =
          container?.getAttribute("data-current-variant") || null;
        const objectIDs = currentVariant ? [currentVariant] : [];

        const clickData = {
          eventName: "Added to cart",
          index: hit.index,
          queryID: hit.queryID,
          objectIDs,
          productId,
        };

        const isFromAlgoliaObject = {
          isAlgoliaProduct: true,
          queryID: hit.queryID,
        };

        // Set flag that this item came from Algolia
        localStorage.setItem(
          "algolia_analytics_is_from_algolia",
          JSON.stringify(isFromAlgoliaObject)
        );

        // eslint-disable-next-line no-undef
        algoliaShopify.saveForConversionTracking(clickData);
        // Save current scroll position to sessionStorage
        if (
          window?.Bedrock?.global_settings
            ?.enable_custom_scroll_restoration_desktop ||
          window?.Bedrock?.global_settings
            ?.enable_custom_scroll_restoration_mobile
        ) {
          const scrollY = window.scrollY || window.pageYOffset;
          sessionStorage.setItem("scrollY", scrollY.toString());
          sessionStorage.setItem("plpUrl", window.location.href);
        }
      };

      window.addEventListener("resize", function () {
        checkMobile();
      });

      const featuredImage = html`<img
        src="${productFeaturedImage}&format=webp&width=400"
        alt="${hit.title}"
        srcset="
          ${productFeaturedImage}&format=webp&width=200 200w,
          ${productFeaturedImage}&format=webp&width=400 400w,
          ${productFeaturedImage}&format=webp&width=600 600w
        "
        width="250"
        height="312"
        data-featured-image="true"
        class="br-image__media"
        sizes="(min-width: 1025px) 20vw, (min-width: 768px) 30vw, 40vw"
        fetchpriority="${index === 1 ? "high" : undefined}"
        loading="${index === 1 ? "eager" : index > 8 ? "lazy" : undefined}"
        decoding="${index > 8 ? "async" : undefined}"
      />`;

      // Since we can't get the hover image until we do the ajax call in br-product-tile.js, add the featured image temporarily
      const hoverImagePlaceholder = html`<img
        src="${productFeaturedImage}&format=webp&width=400"
        alt="${hit.title}"
        srcset="
          ${productFeaturedImage}&format=webp&width=200 200w,
          ${productFeaturedImage}&format=webp&width=400 400w,
          ${productFeaturedImage}&format=webp&width=600 600w
        "
        width="250"
        height="312"
        data-alt-image="true"
        class="br-image__media"
        sizes="(min-width: 1025px) 20vw, (min-width: 768px) 30vw, 40vw"
        loading="lazy"
        decoding="async"
      />`;

      const collectionsAttr = JSON.stringify(hit.collections || []);
      const tagsAttr = JSON.stringify(hit.tags || []);

      // data-product is added br-product-tile via setAttribute
      return html`
        <br-product-tile
          data-is-algolia="true"
          data-product="${hit.handle}"
          data-algolia-index="${hit.index}"
          data-algolia-position="${index}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${variantID}"
          data-handle="${hit.handle}"
          data-variant-id="${variantID}"
          data-distinct="${hit._distinct}"
          data-product-id-container="${productID}"
          data-current-variant="${productID}"
          data-atc-collection="${collectionsAttr}"
          data-atc-tags="${tagsAttr}"
          style="order: ${index}"
          class="ais-product br-product-tile"
        >
          ${getProductSkeletonHTML(html, index)} ${assignSkeletonOrders()}
          <div
            class="br-product-tile__rendered-product !hidden"
            data-position="${index}"
          >
            <div class="br-product-tile__media">
              <a
                href="${productURL}"
                class="relative br-product-tile__media-link"
                data-product-link
                onClick="${(event) => handleItemClickInstantSearch(event, hit)}"
              >
                <!-- br-image -->
                <div
                  class="br-image br-image--use-aspect-ratio br-product-tile__image featured-image"
                  style="--br-media-width:3; --br-media-height:4;"
                >
                  ${featuredImage}
                </div>
                <!-- hover image (img src added via js) -->
                <div
                  class="br-image br-image--use-aspect-ratio br-product-tile__image hover-image"
                  style="--br-media-width:3; --br-media-height:4;"
                >
                  ${hoverImagePlaceholder}
                </div>
              </a>
              <div
                class="br-product-tile__variants"
                product-size-variants
              ></div>
              <button
                class="br-product-tile__variants-toggle"
                size-variants-toggle
              >
                <svg class="shopping-bag-icon">
                  <use xlink:href="#shopping-bag"></use>
                </svg>
              </button>
              <div data-badge-container></div>
              ${addToCartHTML} ${quickViewDesktopHTML} ${quickAddHTML}
            </div>
            <div
              class="br-product-tile__details br-product-tile__name--preloaded-height"
            >
              <a
                class="br-product-tile__name"
                data-algolia-index="${hit.index}"
                data-algolia-position="${index}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${variantID}"
                href="${productURL}"
                data-product-title
                data-product-link
                onClick="${(event) => handleItemClickInstantSearch(event, hit)}"
              >
                ${productTitle}
              </a>
              ${productStyleTitle &&
              html`
                <p class="br-product-tile__attribute" data-variant-title>
                  ${productStyleTitle}
                </p>
              `}
              <!-- Product Price -->
              <div class="br-price__container"></div>
              <!-- Additional Callouts -->
              <div data-callout-container></div>
              <!-- swatches are added here via js -->
              <div data-swatches-container></div>
            </div>
          </div>
        </br-product-tile>
        <style>
          .shopify-app-block .ais-page .ais-Hits-item:nth-child(${index}) {
            order: ${index};
          }
        </style>
        ${quickViewShadow}
      `;
    }
  );
});

// Customize the "no results" page
document.addEventListener("algolia.hooks.initialize", function () {
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchNoResultTemplate",
    function (_defaultTemplate, html) {
      return html`
        <div class="ais-hit-empty">
          <div class="h6 ais-hit-empty--title">
            ${globalLanguage.no_results_for} “${searchString}”
          </div>
          <div class="h5 ais-hit-empty--clears">
            ${globalLanguage.try_modifying}
          </div>
        </div>
      `;
    }
  );
});

// Customize facet items
document.addEventListener("algolia.hooks.initialize", function () {
  // eslint-disable-next-line no-undef
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFacetItemTemplate",
    function (_defaultTemplate, item, html) {
      const facetType = item.attribute;
      if (facetType.includes("color")) {
        addFilterColorSwatches();
      }
      const itemLabel = item.label.replace('["', "").replace('"]', "");
      return html`
        <label
          class="${item.cssClasses.label} ais-facet--${facetType}"
          data-label-value=${itemLabel}
        >
          ${item.type === "disjunctive" &&
          (item.isRefined
            ? html`
                <input
                  type="checkbox"
                  class="${item.cssClasses.checkbox}"
                  checked
                />
              `
            : html`
                <input type="checkbox" class="${item.cssClasses.checkbox}" />
              `)}
          ${itemLabel}
          <span class="${item.cssClasses.count}">
            ${algoliaShopify.helpers.formatNumber(item.count)}
          </span>
        </label>
      `;
    }
  );
});

// Create the custom select dropdown for color filters
function addFilterColorSwatches() {
  const colorFilters = globalSettings.color_filter_options.split(",");
  const colorSwatches = globalSettings.filter_color_swatches;

  window.setTimeout(() => {
    colorFilters.forEach((filter) => {
      // Loop through the color swatches
      colorSwatches.forEach((swatch) => {
        // Check for a match
        if (
          swatch.filter_color_swatch_title.toLowerCase() ===
          filter.toLowerCase()
        ) {
          const colorFilterLabel = document.querySelector(
            ".ais-facet-color .ais-facet-dropdown-container [data-label-value='" +
              swatch.filter_color_swatch_title +
              "']"
          );
          if (
            colorFilterLabel &&
            !colorFilterLabel.querySelector(".color-swatch")
          ) {
            const swatchElement = document.createElement("span");
            swatchElement.classList.add("color-swatch");

            if (swatch.filter_color_swatch_image) {
              swatchElement.style.backgroundImage = `url(https:${swatch.filter_color_swatch_image}&width=52&height=52)`;
              swatchElement.style.backgroundSize = "cover";
              swatchElement.style.backgroundPosition = "center";
            } else {
              swatchElement.style.backgroundColor =
                swatch.filter_color_swatch_color;
            }

            Object.assign(swatchElement.style, {
              border: "1px solid var(--br-color-gray-700)",
              display: "inline-block",
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              marginRight: "8px",
              verticalAlign: "middle",
            });

            const checkbox = colorFilterLabel.querySelector(
              'input[type="checkbox"]'
            );
            if (checkbox && checkbox.nextSibling) {
              colorFilterLabel.insertBefore(
                swatchElement,
                checkbox.nextSibling
              );
            }
          }
        }
      });
    });
  }, 0);
}

/**
 * Generates the skeleton HTML for the product tile.
 *
 * @param {Function} [html] - Optional HTML template function from Algolia.
 * @returns - The skeleton HTML for the product tile.
 */
function getProductSkeletonHTML(html) {
  if (!html) {
    return `
      <div class="br-product-tile__skeleton placeholder">
        <div class="placeholder__tile">
          <div class="placeholder__image"></div>
          <div class="placeholder__text-container">
            <div class="placeholder__text"></div>
            <div class="placeholder__text"></div>
            <div class="placeholder__text"></div>
            <div class="placeholder__swatches"></div>
          </div>
        </div>
      </div>
    `;
  }

  return html`
    <div class="br-product-tile__skeleton placeholder">
      <div class="placeholder__tile">
        <div class="placeholder__image"></div>
        <div class="placeholder__text-container">
          <div class="placeholder__text"></div>
          <div class="placeholder__text"></div>
          <div class="placeholder__text"></div>
          <div class="placeholder__swatches"></div>
        </div>
      </div>
    </div>
  `;
}

/**
 * Assigns order to product skeleton containers to keep them in sync with the actual products and disruptors.
 */
function assignSkeletonOrders() {
  const page =
    parseInt(new URLSearchParams(window.location.search).get("page")) || 1;
  const baseOrder = (page - 1) * 48 + 1;

  const skeletons = Array.from(
    document.querySelectorAll(".br-product-tile__skeleton")
  )
    .map((skeleton) => skeleton.closest(".ais-Hits-item"))
    .filter(Boolean);

  skeletons.forEach((skeletonContainer, index) => {
    skeletonContainer.style.order = baseOrder + index;
  });
}

/**
 * Toggle skeleton display.
 */
function toggleSkeletons() {
  setTimeout(() => {
    const initialSkeletons = document.querySelectorAll(".br-product-tile__skeleton");
    const skeletonsShown = Array.from(initialSkeletons).some(item => item.classList.contains('!hidden'));
    if (skeletonsShown) {
      setTimeout(toggleSkeletons, 500);
    }
    const skeletons = document.querySelectorAll(".br-product-tile__skeleton");
    const renderedProducts = document.querySelectorAll(
      ".br-product-tile__rendered-product"
    );
    const disruptors = document.querySelectorAll(".br-disruptor-tile");

    skeletons.forEach((el) => {
      el.classList.add("!hidden");
    });

    renderedProducts.forEach((el) => el.classList.remove("!hidden"));

    disruptors.forEach((el) => el.classList.remove("!hidden"));

    if (
      savedScrollY &&
      initialLoad &&
      savedPlpUrl === window.location.href &&
      (isBackNavigation || pdpSwatchClicked)
    ) {
      window.scrollTo({
        top: parseInt(savedScrollY, 10),
        behavior: "auto",
      });

      initialLoad = false;
    } else if (initialLoad) {
      initialLoad = false;
    }
  }, 100)
}

class CustomSelect {
  constructor(element) {
    if (element.classList.contains("custom-select-initialized")) {
      // If the class already exists, don't initialize again
      return;
    }

    this.element = element;
    this.createCustomSelect();
    this.addEventListeners();

    // Mark this element as initialized
    this.element.classList.add("custom-select-initialized");
  }

  createCustomSelect() {
    const classes = this.element.className;
    const placeholder = this.element.getAttribute("placeholder") || "Sort";

    // Find the selected option or use the placeholder
    const selectedOption = this.element.querySelector("option:checked");
    const selectedText = selectedOption ? selectedOption.textContent : "";

    // Create the custom select template
    let template = `<div class="${classes} custom-select">`;
    template += `<span class="custom-select-trigger max-md:font-light">
                    <span class="block mobile-text !mr-1 md:hidden max-md:text-[13px]">${placeholder}</span>
                    <span class="custom-select-trigger-value hidden md:block !text-[13px] font-light leading-tight">${selectedText}</span>
                    <span class="br-icon br-icon--sm" aria-hidden="true" style=""><svg><use href="#chevron-down"></use></svg></span>
                  </span>`;
    template += '<div class="custom-options">';

    // Loop through each option and create the custom option elements
    this.element.querySelectorAll("option").forEach((option) => {
      const optionClass = option.className;
      const optionValue = option.value;
      const optionText = option.innerHTML;
      const selectedClass = option.selected ? "selected" : "";

      template += `<span class="custom-option ${optionClass} ${selectedClass}" data-value="${optionValue}">${optionText}</span>`;
    });

    template += "</div></div>";

    // Wrap the original select element in a wrapper
    this.wrapper = document.createElement("div");
    this.wrapper.className = "custom-select-wrapper";
    this.element.parentNode.insertBefore(this.wrapper, this.element);
    this.wrapper.appendChild(this.element);

    // Hide the original select element and add the custom template after it
    this.element.style.display = "none";
    this.wrapper.insertAdjacentHTML("beforeend", template);
  }

  addEventListeners() {
    const customSelect = this.wrapper.querySelector(
      `div.${this.element.className}`
    );
    const customOptions = customSelect.querySelector(".custom-options");
    const customTrigger = customSelect.querySelector(".custom-select-trigger");
    const originalSelect = this.element;

    // Handle click on the custom select trigger
    customTrigger.addEventListener("click", (event) => {
      document.querySelectorAll(".custom-select").forEach((select) => {
        if (select !== customSelect) {
          select.classList.remove("opened");
        }
      });

      customSelect.classList.toggle("opened");
      event.stopPropagation();
    });

    // Close the custom select if clicked outside
    document.addEventListener("click", (event) => {
      if (!customSelect.contains(event.target)) {
        customSelect.classList.remove("opened");
      }
    });

    // Handle selection of a custom option
    customOptions.querySelectorAll(".custom-option").forEach((option) => {
      option.addEventListener("click", () => {
        // Update the value of the original select element
        originalSelect.value = option.getAttribute("data-value");

        // Trigger the change event on the original select element
        originalSelect.dispatchEvent(new Event("change", { bubbles: true }));

        document.querySelectorAll(".br-disruptor-tile").forEach((disruptor) => {
          disruptor.classList.add("!hidden");
        });

        document.querySelectorAll(".placeholder").forEach((skeleton) => {
          skeleton.classList.remove("!hidden");
        });

        // Update the selection class
        customOptions.querySelectorAll(".custom-option").forEach((opt) => {
          opt.classList.remove("selection");
          opt.classList.remove("selected"); // Remove selected class from all options
        });
        option.classList.add("selection");
        option.classList.add("selected"); // Add selected class to the clicked option

        // Close the custom select
        customSelect.classList.remove("opened");

        // Update the trigger text
        customTrigger.querySelector(
          ".custom-select-trigger-value"
        ).textContent = option.textContent;
      });
    });

    // Handle hover effect on the first custom option
    customOptions
      .querySelector(".custom-option:first-of-type")
      .addEventListener("mouseenter", () => {
        customOptions.classList.add("option-hover");
      });

    customOptions
      .querySelector(".custom-option:first-of-type")
      .addEventListener("mouseleave", () => {
        customOptions.classList.remove("option-hover");
      });
  }
}

/**
 * Removes the default scrollRestoration behavior and implements a custom one based on the global settings.
 */
if ("scrollRestoration" in history) {
  const isDesktop = window.matchMedia("(min-width: 768px)").matches;
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const settings = window?.Bedrock?.global_settings;

  const enabled =
    (settings?.enable_custom_scroll_restoration_desktop && isDesktop) ||
    (settings?.enable_custom_scroll_restoration_mobile && isMobile);

  history.scrollRestoration = enabled ? "manual" : "auto";

  if (enabled) {
    window.addEventListener("DOMContentLoaded", () => {
      if (
        !isBackNavigation ||
        savedPlpUrl !== window.location.href ||
        !savedScrollY
      ) {
        return;
      }

      setTimeout(() => {
        window.scrollTo({
          top: parseInt(savedScrollY, 10),
          behavior: "auto",
        });
        // eslint-disable-next-line no-magic-numbers
      }, 750);
    });
  }
}

// Scroll to top of the page when a PLP filter is clicked
window.addEventListener("load", function () {
  const targetNode = document.querySelector(".ais-page");
  if (targetNode) {
    const observerConfig = { childList: true, subtree: true };
    const productObserver = new MutationObserver(() => {
      const aisRefinementItems = document.querySelectorAll(
        ".ais-RefinementList-item"
      );
      if (aisRefinementItems.length > 0) {
        aisRefinementItems.forEach((item) => {
          item.removeEventListener("click", handleRefinementClick);
          item.addEventListener("click", handleRefinementClick);
        });
      }
    });
    productObserver.observe(targetNode, observerConfig);
  }

  function handleRefinementClick() {
    document.querySelectorAll(".br-disruptor-tile").forEach((el) => {
      el.classList.add("!hidden");
    });

    document.querySelectorAll(".br-product-tile__skeleton").forEach((el) => {
      el.classList.remove("!hidden");
    });
  }

  function waitForClearRefinementButton() {
    const clearRefinementBtn = document.querySelector(
      ".ais-ClearRefinements-button"
    );

    if (clearRefinementBtn && !clearRefinementBtn.dataset.listenerAttached) {
      clearRefinementBtn.addEventListener("click", handleRefinementClick);
      clearRefinementBtn.dataset.listenerAttached = "true";
    }
  }

  // Observe for DOM changes where filters appear
  const observer = new MutationObserver(() => {
    waitForClearRefinementButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
